import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { billingGroupApi } from '../../api/lib/billing-group';
import { billingGroupsKeys } from '../../api/query-keys/billing-groups';

export const useCreateBillingGroup = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { t } = useTranslation(['billingGroups']);

  return useMutation({
    mutationFn: ({
      name,
      discountTemplatesIds,
    }: {
      name: string;
      discountTemplatesIds: number[];
    }) => billingGroupApi.createBillingGroup(name, discountTemplatesIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: billingGroupsKeys.all,
      });

      toast.success(
        `${t('billingGroups:create.billingGroup')} ${t('billingGroups:create.created')}`,
      );

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
